import { Text } from 'foundations-components/components/Text';
import { useHistory, useLocation } from 'quartz-routing/react-router';
import { Suspense, lazy } from 'react';
import { CURRENCY_PARAM, useCurrency } from '../context/CurrencyContext';
import { isCurrencyCodeString } from '../utils/currencyTypes';

/*
 * Lazy-load the foundations `Select`-based picker so its `@floating-ui/react`
 * dependency (~275 KB) is code-split into the `currency-picker` chunk rather
 * than the main entry chunk. The picker renders in the sidenav footer on every
 * public page, so a static import would keep floating-ui in `bundles/project.js`.
 * See docs/bundle-optimization-tasks.md (Ticket 2).
 */
import { jsx as _jsx } from "react/jsx-runtime";
const LazyCurrencyPickerSelect = /*#__PURE__*/lazy(() => import( /* webpackChunkName: "currency-picker" */'./PublicCurrencyPickerSelect'));
const PublicCurrencyPicker = () => {
  const {
    availableCurrencyCodes,
    displayedCurrencyCode
  } = useCurrency();
  const history = useHistory();
  const location = useLocation();
  const handleChange = event => {
    const value = event.target.value;
    if (!isCurrencyCodeString(value)) return;
    const params = new URLSearchParams(location.search);
    params.set(CURRENCY_PARAM, value);
    history.replace({
      pathname: location.pathname,
      search: params.toString()
    });
  };
  return (
    /*#__PURE__*/
    /* Fallback shows the current currency code (no floating-ui) so the footer
       doesn't shift while the picker chunk loads. */
    _jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "body-125",
        paddingBlock: "250",
        paddingInline: "300",
        display: "inline-block",
        children: displayedCurrencyCode
      }),
      children: /*#__PURE__*/_jsx(LazyCurrencyPickerSelect, {
        availableCurrencies: availableCurrencyCodes,
        selectedCurrency: displayedCurrencyCode,
        onChange: handleChange
      })
    })
  );
};
export default PublicCurrencyPicker;